<template>
    <div
        v-if="usableNotifications.length > 0"
        class="p-sm gap-sm mr-md flex w-80 cursor-pointer flex-nowrap items-center overflow-hidden rounded-sm bg-(--state-danger-bg)"
        @click="usableNotifications.length > 1 ? openDialog() : $emit('route', usableNotifications[0].id)"
    >
        <i class="i-warning" />

        <p v-if="usableNotifications.length === 1">
            {{ usableNotifications[0].title }}
        </p>
        <p v-else>
            You have
            <span class="text-bold font-bold">{{ usableNotifications.length }}</span>
            active critical notifications!
        </p>
    </div>

    <dialog ref="dialog-ref" class="w-[90%] rounded-md bg-(--overlay-surface) shadow-md md:w-1/2">
        <div class="p-md gap-md flex flex-col" tabindex="0">
            <NotificationList
                :notifications="
                    usableNotifications.filter(
                        (n) =>
                            n.severity === NOTIFICATION_SEVERITY.CRITICAL &&
                            (n.endDate === undefined || n.endDate.getTime() >= new Date().getTime()),
                    )
                "
                ongoing
                :notification-filter="[]"
                @route="($emit('route', $event), dialog?.close())"
            />
            <div class="gap-md flex">
                <Button
                    @click="
                        () => {
                            currentRouter?.push({ name: 'notifications' });
                            dialog?.close();
                        }
                    "
                >
                    Open notification overview
                </Button>
                <button class="btn-link" @click="dialog?.close()">Cancel</button>
            </div>
        </div>
    </dialog>
</template>

<script lang="ts" setup>
import { Button } from '@/components/ui/button';
import { NOTIFICATION_SEVERITY, type Notification } from '@/stores/store-interfaces';
import { computed, onMounted, ref, useTemplateRef, type PropType } from 'vue';
import type { Router } from 'vue-router';
import NotificationList from './notification-list.vue';
const props = defineProps({
    notifications: { type: Array as PropType<Notification[]>, required: true },
    router: { type: Object as PropType<Router>, required: true },
});

const currentRouter = ref<Router>();
const dialog = useTemplateRef('dialog-ref');

const usableNotifications = computed(() =>
    props.notifications.filter(
        (n) =>
            n.severity === NOTIFICATION_SEVERITY.CRITICAL &&
            (n.endDate === undefined || n.endDate.getTime() >= new Date().getTime()),
    ),
);

onMounted(() => {
    currentRouter.value = props.router;
});

const openDialog = () => {
    if (!dialog.value) return;
    dialog?.value.showModal();
};

defineEmits(['route']);
</script>

<style scoped>
@reference '@/assets/styles/default.css';
p {
    @apply w-full overflow-hidden text-ellipsis whitespace-nowrap text-(--state-danger-fg);
}
</style>
